// extracted by mini-css-extract-plugin
export default {"fadeInSection":"FadeInSection_fadeInSection__UoiYG","isVisible":"FadeInSection_isVisible__BrNJP"};